/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import { Chart } from 'react-google-charts';
import { graficoIntervencionesPayments } from '../../Api';
import { setTitlePage } from '../../Functions';

const EvolutionaryChartPayments = () => {
  const [data, setData] = useState({});
  const [type, setType] = useState(1);
  const [loading, setLoading] = useState(false);
  const [count, setCount] = useState(0);

  const getData = async (type) => {
    setLoading(true);
    let chart = [];
    const _response = await graficoIntervencionesPayments({
      input_tipo_pago: parseInt(type),
    });
    console.info(type);
    if (parseInt(type) === 1) {
      chart = [...chart, ['Element', 'Primera Quincena', 'Segunda Quincena']];
    } else {
      chart = [...chart, ['Element', 'Pagos']];
    }
    const count = _response.data.count;
    _response.data.pagos.forEach((element) => {
      if (parseInt(type) === 1) {
        chart = [
          ...chart,
          [element.anio, element.primeraquincena, element.segundaquincena],
        ];
      } else {
        console.info('22222');
        chart = [...chart, [element.anio, element.pagos]];
      }
    });
    setData(chart);
    setLoading(false);
    setCount(count);
  };

  useEffect(() => {
    getData(type);
    setTitlePage('Gráfico Evolutivo de Pagos');
  }, []);

  const handleChart = (e) => {
    getData(parseInt(e.target.value));
    setType(parseInt(e.target.value));
  };

  const options = {
    title: '',
    isStacked: true,
    legend: parseInt(type) !== 1 ? { position: 'none' } : {},
    height: 'auto',
    hAxis: {
      title: 'Meses',
      titleTextStyle: {
        color: '#f3f3f3',
      },
      slantedText: true,
      slantedTextAngle: 30,
    },
    vAxis: {
      title: 'Montos ($)',
    },
  };

  return (
    <div className="card py-3">
      <div className="card-body">
        <div className="border-bottom my-3 pb-2">
          <h3>Evolutivo de Pagos HMQ</h3>
          <div className="inputs-grafic my-5">
            <span className='mx-3'>
              <input
                className='form-check-input'
                type="radio"
                name="radio"
                value={1}
                checked={type === 1}
                onClick={handleChart}
                onChange={e => {}}
              />{' '}
              HMQ
            </span>
            <span className='mx-3'>
              <input
                className='form-check-input'
                type="radio"
                name="radio"
                value={2}
                checked={type === 2}
                onClick={handleChart}
                onChange={e => {}}
              />{' '}
              Consultas
            </span>
            <span className='mx-3'>
              <input
                className='form-check-input'
                type="radio"
                name="radio"
                value={3}
                checked={type === 3}
                onClick={handleChart}
                onChange={e => {}}
              />{' '}
              Todos
            </span>
          </div>
        </div>
        {loading && <div className="spinner text-center">Cargando...</div>}
        <div style={loading ? { display: 'none' } : {}}>
          {count > 0 ? (
            <Chart
              chartType="ColumnChart"
              width="100%"
              height="400px"
              data={data}
              options={options}
            />
          ) : (
            <div className="text-center">No hay datos registrados</div>
          )}
        </div>
      </div>
    </div>
  );
};

export default EvolutionaryChartPayments;